export const PRICING = {
  PLAN_NAMES: {
    ZERO_MILE: 'Low Gear Plan',
    FIVE_HUNDRED_MILE: 'Local Driver Plan',
    EIGHT_FIFTY_MILE: 'Standard Plan',
    TWELVE_HUNDRED_MILE: 'Cruiser Plan',
    EXTRA_HIGH_MILE: 'Road Warrior Plan',
    PLAN_MILE_SUFFIX: 'Miles',
  },
  LEGACY_PLAN_NAMES: {
    MONTHLY: 'Pre-pay monthly',
    WEEKLY: 'Weekly',
  },
  NO_PLAN: 'No Active Plan',
};
